import { LocationModel } from 'models/CompanySetup/location.model';
import { TableColumnsType } from 'antd';
import { SortingTypesEnums } from 'enums/sortingTypes.enum';
import { SortOrder } from 'antd/lib/table/interface';
import { SortingProps } from 'views/OrganisationDetails/LocationDetails';
import {
  AllProductListTableColumns,
  AllProductListTableFields,
} from 'enums/AllProductListEnums';

export const sortDirectionMap: {
  [key: string]:
    | SortingTypesEnums.ASCEND
    | SortingTypesEnums.DESCEND
    | undefined;
} = {
  '': SortingTypesEnums.ASCEND,
  ascend: SortingTypesEnums.DESCEND,
  descend: undefined,
};

const AllProductsColumns = (props: {
  sortedInfo: SortingProps;
}): TableColumnsType<LocationModel> => {
  const { sortedInfo } = props;

  const getSortOrder = (fieldName: string) => {
    return sortedInfo?.columnKey === fieldName
      ? (sortedInfo?.order as SortOrder)
      : null;
  };
  return [
    {
      title: AllProductListTableColumns.PRODUCT_NAME,
      dataIndex: AllProductListTableFields.NAME,
      key: AllProductListTableFields.NAME,
      sorter: true,
      sortOrder: getSortOrder(AllProductListTableFields.NAME),
    },
    {
      title: AllProductListTableColumns.IN_REVIEW,
      key: AllProductListTableFields.IN_REVIEW,
      dataIndex: AllProductListTableFields.IN_REVIEW,
      sorter: true,
      sortOrder: getSortOrder(AllProductListTableFields.IN_REVIEW_KEY),
    },
    {
      title: AllProductListTableColumns.VERIFIED,
      key: AllProductListTableFields.APPROVED,
      dataIndex: AllProductListTableFields.APPROVED,
      sorter: true,
      sortOrder: getSortOrder(AllProductListTableFields.APPROVED),
    },
    {
      title: AllProductListTableColumns.DRAFT,
      dataIndex: AllProductListTableFields.DRAFT,
      key: AllProductListTableFields.DRAFT,
      sorter: true,
      sortOrder: getSortOrder(AllProductListTableFields.DRAFT),
    },
    {
      title: AllProductListTableColumns.DECLINED,
      dataIndex: AllProductListTableFields.DECLINED,
      key: AllProductListTableFields.DECLINED,
      sorter: true,
      sortOrder: getSortOrder(AllProductListTableFields.DECLINED),
    },
    {
      title: AllProductListTableColumns.TOTAL,
      dataIndex: AllProductListTableFields.TOTAL,
      key: AllProductListTableFields.TOTAL,
      sorter: true,
      sortOrder: getSortOrder(AllProductListTableFields.TOTAL),
    },
  ];
};

export default AllProductsColumns;
